import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { IonicModule } from '@ionic/angular';

import { ModalEditarTrabajadorPageRoutingModule } from './modal-editar-trabajador-routing.module';

import { ModalEditarTrabajadorPage } from './modal-editar-trabajador.page';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    ModalEditarTrabajadorPageRoutingModule
  ],
  declarations: [ModalEditarTrabajadorPage]
})
export class ModalEditarTrabajadorPageModule {}
